var site = site || {};
site.ProductSearch = (function () {

    var processSearchResponse = function (data) {
        $('#searchResults').html('');
        $('#searchResults').append(data.productSearchResults);
        $('#pagination').html('');
        $('#pagination').append(data.pagination);
        $('#accordion').html('');
        $('#accordion').append(data.searchFacets);
        if ($('#searchTextBox').val().length > 0) {
            $('#resultsCount').html('<strong>' + data.productResultsCount + '</strong> results for "' + $('#searchTextBox').val() + '"');
        } else {
            $('#resultsCount').html('<strong>' + data.productResultsCount + '</strong> results');
        }

        $('.js-body-system-link[href="' + window.location.pathname + '"]').addClass('fw-bold');
        site.Drawer.openDrawer();
        site.Drawer.productAddAndRemove();
        site.Drawer.removeProductFromDrawer();
        site.ProductSearch.unselectDefaultBrands();
        if (data.productResultsCount > 0) {
            $('#noSearchResults').addClass('d-none');
            $('#pageSizeContainer').removeClass('d-none');
        } else {
            $('#noSearchResults').removeClass('d-none');
            $('#pageSizeContainer').addClass('d-none');
        }
    }
    var submitSearch = function (pageNumber) {
        site.Search.removeSuggestions();
        var query = site.Search.buildQuery(pageNumber);
        $.ajax({
            method: "POST",
            url: "/products/search",
            dataType: "json",
            data: JSON.stringify(query),
            contentType: "application/json"
        })
            .done(function (data) {
                
                processSearchResponse(data);
                site.Search.scrollToReloadAnchor();
                site.Search.showHideFacets();
                site.Search.showHideReset();
            })
            .fail(function (data) {
                console.log(data)
            });
        return false;
    };

    var getResourceTypes = function () {
        if ($('#productSearchCategory').val() == 'GlobalSearch') {
            var query = site.Search.buildQuery(1);
            query.pageSize = 1;
            $.ajax({
                method: "POST",
                url: "/products/resourceTypes",
                dataType: "json",
                data: JSON.stringify(query),
                contentType: "application/json"
            })
                .done(function (data) {
                    $('#resourceTypeFacets').html(data);
                    var facets = site.Search.getFacetsFromUrl();
                    var selector = facets["resourceCategories"]?.replace("|", "");
                    var $selectedFacet = $('#filter-resourceCategories-' + selector);
                    $selectedFacet.prop('checked', true);
                    site.Search.setFacetPillsFromQueryString();
                })
                .fail(function (data) {
                    console.log(data)
                });
        }
        return false;
    }

    function bindSearchPageEvents() {
        $(document).on('click', "#searchSubmitButton", function () {
            site.Search.removeSelectedFacets();
            $('.js-facet-pills-container').html('');
            if ($('#productSearchCategory').val() != 'AllProducts' && $('#productSearchCategory').val() != 'GlobalSearch') {
                var query = site.Search.buildQuery(1);
                window.location.href = '/products' + window.location.search;
            } else {
                submitSearch(1);
                getResourceTypes();
            }
        });
        $(document).on('click', '.js-pagination', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var pageNumber = $(this).data().pagenumber
            submitSearch(pageNumber);
            var position = $('#reload-anchor').offset().top;

            $("body, html").animate({
                scrollTop: position
            } /* speed */);
            return false;
        });
        $(document).on('click', '.js-facet-filter', function (e) {
            submitFacetSearch(this);
            $('#refineResults').find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        });
        $(document).on('click', '.js-filter-reset', function () {

            site.Search.removeSelectedFacets();
            $('.js-facet-pills-container').html('');
            getResourceTypes();
            submitSearch(1);
            $('#refineResults').find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        });

        $(document).on('click', 'span.sortOrderOptions', e => {
            var target = e.target;
            $(".dropbtn").html(target.innerHTML + "<i class=\"fas fa-angle-down float-end\"></i>")
            $("#sortOrder > span").attr('class', 'sortOrderOptions')
            target.classList.add("activeOption")

            //Ensure URL gets appropriately updated
            if (window.location.search.match("&sortOrder=") || window.location.search.match("sortOrder=")) {
                name = "sortOrder".replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
                results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
                var newURL = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search.replace(results[1], e.target.dataset.option)
                window.history.pushState({ path: newURL }, '', newURL);


            }
            submitSearch(1)
        });

        $(document).on('click', '.js-facet-pill', function (e) {
            site.Search.removeFromUrl(this.dataset.facetFieldname, this.dataset.facetKey);
            site.Search.removeFacetPill(this.dataset.facetKey);
            if (this.dataset.facetFieldname == 'resourceCategories') {
                site.Search.removeSelectedFacets();
                $('.js-facet-pills-container').children('.js-facet-pill').remove();
                getResourceTypes();
            }
            submitSearch(1);
            $('#refineResults').find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        })

        $(document).on('change', '#pageSize', function () {
            submitSearch(1);
        })
    }

    function submitFacetSearch(facet) {
        var url = window.location.href;
        var urlObject = new URL(url);
        var val = $(facet).data('value');
        var fieldName = $(facet).data('fieldname');
        var displayName = $(facet).data('displayname') != null ? $(facet).data('displayname') : $(facet).data('value') ;
        if (fieldName != "resourceCategories") {
            if (facet.checked) {
                site.Search.appendToUrl(fieldName, val);
                site.Search.addFacetPill(val, displayName, fieldName);
            } else {
                site.Search.removeFromUrl(fieldName, val);
                site.Search.removeFacetPill(val, displayName);
            }
        } else {
            let urlResourceType = urlObject.searchParams.get('resourceCategories');

            var resourceTypesToBeMapped = [
                "SALES",
                "LIT",
                "MRCH",
            ];

            if (resourceTypesToBeMapped.includes(urlResourceType)) {
                urlResourceType = "PRD|" + urlResourceType;
            }

            if (typeof urlResourceType != "undefined" && urlResourceType != null) {
                if (urlResourceType != val) {
                    site.Search.removeFromUrl(fieldName, urlResourceType);
                    site.Search.appendToUrl(fieldName, val);
                } else {
                    site.Search.removeFromUrl(fieldName, val);
                }
            } else {
                site.Search.appendToUrl(fieldName, val);
            }

            $('.js-facet-pills-container').children('.js-facet-pill').remove();
        }
        getResourceTypes();
        submitSearch(1);
    }
    function removeCurrentResourceTypeSearch() {

    }

    var activeCallback = function (productGuid) {
        $(".js-favorite-icon[data-productguid*=" + productGuid + "]")
            .data('isfavorite', 'True')
            .addClass('favorite__img active')
            .removeClass('favorite__link');
    }
    var removeCallback = function (productGuid) {
        $(".js-favorite-icon[data-productguid*=" + productGuid + "]")
            .data('isfavorite', 'False')
            .removeClass('favorite__img active')
            .addClass('favorite__link');
    }
    var unselectDefaultBrands = function () {
        var params = site.Search.getFacetsFromUrl();
        if (params && params.brands) {

        } else {
            $('.js-facet-filter[data-fieldname="brands"]').prop('checked', false)
        }
    }

    return {
        processSearchResponse: processSearchResponse,
        submitSearch: submitSearch,
        bindSearchPageEvents: bindSearchPageEvents,
        activeCallback: activeCallback,
        removeCallback: removeCallback,
        unselectDefaultBrands: unselectDefaultBrands,
        getResourceTypes: getResourceTypes
    }
}());

//-----------------------------------------------------------------------
// DOCUMENT READY
//-----------------------------------------------------------------------
$(document).ready(function () {
    site.ProductSearch.bindSearchPageEvents();
    site.Search.bindSuggestionPageEvents();
    site.Search.showHideFacets();
    site.Search.showHideReset();


    //select first option on page load: for bug fix 4037
    $('.js-product-dropdown').prop("selectedIndex", 0)
    if ($('#searchTextBox').val().length > 0) {
        $('#resultsCount').append('for "' + $('#searchTextBox').val() + '"');
    }
    site.ProductSearch.unselectDefaultBrands();
    if ($('#productSearchCategory').val() == "GlobalSearch") {
        site.ProductSearch.getResourceTypes();
    }
    else {
        site.Search.setFacetPillsFromQueryString();
    }
});

//-----------------------------------------------------------------------
// WINDOW RESIZE
//-----------------------------------------------------------------------

$(window).smartresize(function () {
    site.Search.showHideFacets();
}, 200);

$('.js-quantity-selector').on('keyup change', function () {
    var qtySelector = $(this),
        errorMessage = qtySelector.parent().next('.js-quantity-error'),
        addToCartButton = qtySelector.next('.js-add-product-to-cart'),
        addToCartContainer = qtySelector.parent('.js-atc-container'),
        partRestriction = qtySelector.parent().siblings('.js-part-in-cart-message:visible');

    var min = qtySelector.attr('min'),
        max = qtySelector.attr('max'),
        currentVal = parseInt(qtySelector.val());

    // var quantityStats = [["min", min], ["max", max], ["current", currentVal]];
    // console.table(quantityStats);

    if (currentVal <= max && currentVal >= min) {
        addToCartButton.attr('disabled', partRestriction.length > 0);
        if (errorMessage.is(':visible')) {
            errorMessage.detach();
        }
    } else if (currentVal > max || isNaN(currentVal) || currentVal <= min) {
        addToCartButton.attr('disabled', true);
        if (!errorMessage.is(':visible')) {
            addToCartContainer.after("<p class='js-quantity-error alert alert-danger px-2 py-1 w-100 text-center text-14 mb-0 mt-3'>Please select a quantity between " + min + " and " + max + "</p>")
        }
    }
});